import React from "react";
import { useTranslation } from 'react-i18next';

// components:
import Loader from '../Loader'

const OrderSingle = ({ screenSize, darkModeState, handleSubmit, edit, handleChange, handleDelete, optionSelected, loader, nif, nro_documento, nombre_sociedad, importe_ml, fecha_doc, fecha_envio, enviado, orderId }) => { //nif_emisor,cuenta,
    const styles = {
        buttons: {
            display: "flex",
            flexDirection: 'row',
            margin: 0
        },
        buttonDelete: {
            textDecoration: "none",
            color: "#fff",
            backgroundColor: "hsl(356, 69%, 56%)",
            border: 'none',
            margin: "20px 0px",
            // margin: `${screenSize > 940 ? ('1.4%') : ("10px")}`,
            width: `${screenSize > 940 ? ('180px') : (<></>)}`,
        },
        buttonEdit: {
            textDecoration: "none",
            color: "#fff",
            backgroundColor: "#4dc2f1",
            border: 'none',
            margin: "20px",
            // margin: `${screenSize > 940 ? ('1.4%') : ("10px")}`,
            width: `${screenSize > 940 ? ('180px') : (<></>)}`,
        },
        checkbox: {
            display: 'flex',
            alignItems: 'center',
            margin: '0px 0px 10px 3px'
        },
        checkbox2: {
            display: 'flex',
            alignItems: 'center',
            margin: '0px 0px 25px 3px'
        },
        container: {
            // position: "fixed",
            bottom: 0,
            top: 0,
            left: 0,
            right: 0,
            display: "flex",
            flexDirection: "column",
            //   padding: `${screenSize > 940 ? ("3% 2% 3% 20%") : ("30px")}`,
            padding: `${screenSize > 940 ? ("3% 2% 3% 21%") : ("3% 9% 9% 9%")}`,
            height: "100%",
            overflow: `auto`,
        },
        form: {
            width: '100%',
            margin: '10px 0px'
        },
        input: {
            fontFamily: "InterRegular",
            fontSize: "16px",
            color: `${darkModeState ? ("hsl(228, 34%, 66%)") : ("hsl(228, 12%, 44%)")} `,
            margin: '0px 0px 25px',
        },
        inputCheckbox: {
            fontFamily: "InterRegular",
            fontSize: "16px",
            border: '1px solid red',
        },
        label: {
            margin: '0px 0px 15px',
            fontSize: "18px",
            fontFamily: "InterBold",
            color: `${darkModeState ? ("hsl(228, 34%, 66%)") : ("hsl(228, 12%, 44%)")} `,
        },
        labelCheckbox: {
            fontFamily: "InterRegular",
            fontSize: "16px",
            color: `${darkModeState ? ("hsl(228, 34%, 66%)") : ("hsl(228, 12%, 44%)")} `,
        },
        navbar: {
            display: "flex",
            flex: 1.5,
            margin: `${screenSize > 940 ? ("0px 20px") : ("0px")}`,
            marginBottom: `${screenSize > 940 ? ("0px") : ("30px")}`,
        },
        orders: {
            display: "flex",
            flex: 11,
            flexDirection: "column",
            alignItems: 'center',
            margin: `${screenSize > 940 ? ("0px 20px") : ("0px")}`,
            //  justifyContent: 'space-between',
            //   margin: `${screenSize > 940 ? ('20px 0px') : ("0px 0px 30px")}`,
        },
        subtitleNavbar: {
            margin: 0,
            fontSize: "14px",
            color: `${darkModeState ? ("hsl(228, 34%, 66%)") : ("hsl(228, 12%, 44%)")}`,
            fontFamily: "InterBold",
        },
        textsNavbar: {
            display: "flex",
            flex: 8,
            flexDirection: "column",
        },
        titleNavbar: {
            marginBottom: `${screenSize > 940 ? ('5px') : ("10px")}`,
            fontSize: "28px",
            color: `${darkModeState ? ("hsl(0, 0%, 100%)") : ("hsl(230, 17%, 14%)")}`,
            fontFamily: "InterBold",
            lineHeight: '1.4'
        },

    };

    // eslint-disable-next-line no-unused-vars
    const { t, i18n } = useTranslation();

    // let msgRol = t('SINGLE_ROL_SUBTITLE').replace('{{name}}', rolName);
    // let msgOrderId = t('SINGLE_ORDER_SUBTITLE').replace('{{id}}', `${nif_emisor}-${nif}-${nro_documento}`);
    //usamos orderId que lo pasamos por props al quitar de la interfaz el nif emisor, que no nos hace falta y establecemos el de Newba por defecto en elbacken
    // console.log(orderId)
    let msgOrderId = t('SINGLE_SHIPPING_SUBTITLE').replace('{{id}}', orderId);

    return (
        <>
            <div style={styles.container}>
                {loader ? (
                    <div style={{ "marginTop": "10vh" }}>
                        <Loader
                            type="tailspin"
                        />
                    </div>
                ) : (<>
                    <div style={styles.navbar}>
                        <div style={styles.textsNavbar}>
                            <h3 style={styles.titleNavbar}>{t('SINGLE_ORDER_TITLE')}</h3>
                            <h3 style={styles.subtitleNavbar}>{msgOrderId}</h3>
                        </div>
                    </div>

                    <div style={styles.buttons}>
                        {edit ? (<button type="submit" className="btn" style={styles.buttonEdit} onClick={() => { handleSubmit() }}>{t('BUTTON_SINGLE_ORDER_SAVE')}</button>
                        ) : (<button type="submit" className="btn" style={styles.buttonEdit} onClick={() => { handleSubmit() }}>{t('BUTTON_SINGLE_ORDER_EDIT')}</button>)}
                        <button style={styles.buttonDelete} className="btn btn-primary" onClick={() => { handleDelete() }}>{t('BUTTON_SINGLE_ORDER_DELETE')}</button>
                    </div>
                    <div style={styles.orders}>
                        <form
                            onSubmit={(e) => handleSubmit(e)}
                            style={styles.form}>
                            <div className="form-group" >
                                <br></br>

                                <label style={styles.label}>{t('SINGLE_ORDER_NIF')}</label>
                                <input onChange={(e) => handleChange(e)} name="nif" type="text" className="form-control" style={styles.input} value={nif} placeholder={t('PH_SINGLE_ORDER_NIF')} disabled={(true)} />

                                {/* <label style={styles.label}>{t('SINGLE_ORDER_EMISOR')}</label>
                                <input onChange={(e) => handleChange(e)} name="nif_emisor" type="text" className="form-control" style={styles.input} value={nif_emisor} placeholder={t('PH_SINGLE_ORDER_EMISOR')} disabled={(true)} /> */}

                                {/* <label style={styles.label}>{t('SINGLE_ORDER_CUENTA')}</label>
                                <input onChange={(e) => handleChange(e)} name="cuenta" type="text" className="form-control" style={styles.input} value={cuenta} placeholder={t('PH_SINGLE_ORDER_CUENTA')} disabled={(true)} /> */}

                                <label style={styles.label}>{t('SINGLE_ORDER_SOCIEDAD')}</label>
                                <input onChange={(e) => handleChange(e)} name="nombre_sociedad" type="text" className="form-control" style={styles.input} value={nombre_sociedad} placeholder={t('PH_SINGLE_ORDER_SOCIEDAD')} disabled={(true)} />

                                <label style={styles.label}>{t('SINGLE_ORDER_NRODOC')}</label>
                                <input onChange={(e) => handleChange(e)} name="nro_documento" type="text" className="form-control" style={styles.input} value={nro_documento} placeholder={t('PH_SINGLE_ORDER_NRODOC')} disabled={(true)} />

                                <label style={styles.label}>{t('SINGLE_ORDER_FECHADOC')}</label>
                                <input onChange={(e) => handleChange(e)} name="fecha_doc" type="date" className="form-control" style={styles.input} value={fecha_doc} placeholder={t('PH_SINGLE_ORDER_FECHADOC')} disabled={edit ? (false) : (true)} />

                                <label style={styles.label}>{t('SINGLE_ORDER_IMPORTE')}</label>
                                <input onChange={(e) => handleChange(e)} name="importe_ml" type="text" className="form-control" style={styles.input} value={importe_ml} placeholder={t('PH_SINGLE_ORDER_IMPORTE')} disabled={edit ? (false) : (true)} />

                                <label style={styles.label}>{t('SINGLE_ORDER_FECHAENVIO')}</label>
                                <input onChange={(e) => handleChange(e)} name="fecha_envio" type="date" className="form-control" style={styles.input} value={fecha_envio} placeholder={t('PH_SINGLE_ORDER_FECHAENVIO')} disabled={edit ? (false) : (true)} />

                                <label style={styles.label}>{t('SINGLE_ORDER_ENVIADO')}</label>
                                <div className="form-check" style={styles.checkbox}>
                                    <input className="form-check-input" style={styles.inputCheckbox} name="enviadoTrue" onChange={(e) => handleChange(e, 'type')} type="radio" value="option1" id="flexCheckChecked1" disabled={edit ? (false) : (true)} checked={optionSelected === "option1"} />
                                    <label className="form-check-label" style={styles.labelCheckbox} htmlFor="flexCheckChecked1">{t('YES')}</label>
                                </div>
                                <div className="form-check" style={styles.checkbox2}>
                                    <input className="form-check-input" style={styles.inputCheckbox} name="enviadoFalse" onChange={(e) => handleChange(e, 'type')} type="radio" value="option2" id="flexCheckChecked2" disabled={edit ? (false) : (true)} checked={optionSelected === "option2"} />
                                    <label className="form-check-label" style={styles.labelCheckbox} htmlFor="flexCheckChecked2">{t('NO')}</label>
                                </div>
                            </div>
                        </form>
                    </div>
                </>
                )}
            </div>
        </>
    );
};

export default OrderSingle